export const OddStatus = {
    active: 'active',
    stop: 'stop',
    block: 'block',
    finished: 'finished',
    lost: 'lost',
    refund: 'refund',
    win: 'win',
} as const;
export type OddStatus = typeof OddStatus[keyof typeof OddStatus];

type DoneOddStatuses = Record<OddStatus, boolean>;

export const doneOddStatuses: DoneOddStatuses = {
    active: false,
    stop: false,
    block: false,
    finished: true,
    lost: true,
    refund: true,
    win: true,
} as const;
